import React from "react";
import { MonitorPlay, Cloud, MessageSquare, Youtube, Music, Twitch, Zap } from "lucide-react";
import ObsSetup from "@/components/ObsSetup";
import { SectionBlock } from "./Channel";

const PLACEHOLDERS = [
  { key: "discord", label: "Discord",  icon: MessageSquare, color: "cyan",   desc: "Auto-post going-live announcements + role sync." },
  { key: "youtube", label: "YouTube",  icon: Youtube,       color: "pink",   desc: "Cross-post VODs to your channel." },
  { key: "tiktok",  label: "TikTok",   icon: Music,         color: "volt",   desc: "Share stream clips as TikToks." },
  { key: "twitch",  label: "Twitch",   icon: Twitch,        color: "orange", desc: "Multistream to Twitch simultaneously." },
  { key: "kick",    label: "Kick",     icon: Zap,           color: "cyan",   desc: "Multistream to Kick." },
];

/**
 * Integrations — OBS + Cloudflare are functional; social integrations are
 * connect-your-account placeholders. Clicking "Connect" tags them with
 * `SOON` since OAuth is a Phase 2 undertaking.
 */
export default function Integrations() {
  return (
    <div className="space-y-6 max-w-4xl" data-testid="section-integrations">
      <SectionBlock icon={MonitorPlay} title="OBS / Streaming Software" color="volt">
        <ObsSetup />
      </SectionBlock>

      <SectionBlock icon={Cloud} title="Cloudflare Stream" color="cyan">
        <p className="text-xs text-zinc-400">
          Cloudflare-backed live ingest is fully configured on MystiCast. Your RTMP/SRT ingest URL and stream key are
          available in the OBS setup card above — every stream is automatically recorded as a VOD and stored in
          Emergent Object Storage.
        </p>
        <div className="text-[10px] sc-mono text-zinc-500 mt-2" data-testid="integrations-cloudflare-status">
          ● CONNECTED · MANAGED BY MYSTICAST
        </div>
      </SectionBlock>

      <SectionBlock icon={MessageSquare} title="Social Integrations" color="pink">
        <div className="grid sm:grid-cols-2 gap-3">
          {PLACEHOLDERS.map((p) => (
            <div key={p.key} className="term-card p-4 flex items-center gap-3" data-testid={`integrations-${p.key}`}>
              <div className="w-10 h-10 rounded grid place-items-center shrink-0" style={{ background: `var(--sc-${p.color})15`, border: `1px solid var(--sc-${p.color})40` }}>
                <p.icon className="w-4 h-4" style={{ color: `var(--sc-${p.color})` }} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="sc-heading text-sm font-black">{p.label}</div>
                <div className="text-[11px] text-zinc-500 truncate">{p.desc}</div>
              </div>
              <span className="text-[9px] sc-mono px-1.5 py-0.5 rounded bg-white/5 text-zinc-500 shrink-0">SOON</span>
            </div>
          ))}
        </div>
      </SectionBlock>
    </div>
  );
}
